export enum SignUpFields {
  accountId,
  accountName,
  firstName,
  lastName,
  legalEntity,
  phone,
  referralCode
}

export enum AuthCallbackMessageType {
  EMAIL_VERIFIED = 'EMAIL_VERIFIED'
}

export interface SignUpFieldConfig {
  field: SignUpFields;
  placeholder?: string;
  prefill?: string;
}

export interface ValidationResult {
  hint?: string;
  valid: boolean;
}

const invalid = (reason?: string): ValidationResult => {
  const result: ValidationResult = { valid: false };
  if (reason) {
    result.hint = reason;
  }
  return result;
};

const valid = (): ValidationResult => ({ valid: true });

// a centralized place to own optional signup fields. This will likely be enhanced with icons & validations
export const SIGNUP_FIELDS_MAP = {
  [SignUpFields.referralCode]: {
    name: 'referralCode',
    placeholder: 'Referral code'
  },
  [SignUpFields.accountId]: {
    name: 'accountId',
    placeholder: 'Account id'
  },
  [SignUpFields.accountName]: {
    name: 'accountName',
    placeholder: 'Account name (e.g. Caddi Farm)'
  },
  [SignUpFields.firstName]: {
    name: 'firstName',
    placeholder: 'First name'
  },
  [SignUpFields.lastName]: {
    name: 'lastName',
    placeholder: 'Last name'
  },
  [SignUpFields.legalEntity]: {
    name: 'legalEntityName',
    placeholder: 'Legal entity name'
  },
  [SignUpFields.phone]: {
    name: 'phone',
    placeholder: 'Mobile phone',
    validator: (value: string): ValidationResult => {
      const phone = value.replace(/[\s()-.]+/gi, '');
      if (!phone) {
        return invalid();
      }

      if (!/^\d+$/.test(phone)) {
        return invalid('Phone number must only contain digits');
      }

      if (phone.length < 10) {
        return invalid('Phone number too short');
      }

      if (phone.length > 11) {
        return invalid('Phone number too long');
      }

      return valid();
    }
  }
};
